var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./BahntechnikMoviesList.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-54dd6df7\",\"hasScoped\":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./BahntechnikMoviesList.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/BahntechnikMoviesList.vue
// module id = 64
// module chunks = 0